import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {Inject} from "inversify-props";
import {CreditService} from "@/app/services/credit.service";
import {INDIE_CONSTANTS} from "@/app/shared/common/constants";

@Component<FlightsDetailsComponent>({
  components: ({})
})
export default class FlightsDetailsComponent extends Vue {
  @Inject() public creditService: CreditService;
  @Prop() private segments: any;
  @Prop() private totalStops: number;
  @Prop() private flightDetails: boolean;
  @Prop() private propsNextStep: Function;
  @Prop() private propsCheckFlightDetails: Function;
  @Prop() private propsPersons: any;
  @Prop() private currency: any;
  @Prop() private usingCredit: boolean;

  public selectedSegments: any = this.segments;
  public stops: any = this.totalStops;
  public check = this.flightDetails;
  public nextStep = this.propsNextStep;
  public checkFlightDetails = this.propsCheckFlightDetails;

  private persons = this.propsPersons;

  private sendingRebookingRequest = false

  constructor() {
    super();
    this.selectedSegments = this.segments;
    this.stops = this.totalStops;
  }

  mounted() {
    return true;
  }

  private useCredit(){
    this.sendingRebookingRequest = true;
    this.creditService.useCredit(this.$store).then(res => {
      this.$store.dispatch("storeCreditUrlParam", null);
      this.$store.dispatch("storeCreditData", null);
      this.$cookies.set(INDIE_CONSTANTS.CREDIT_STRING_COOKIE_KEY, null);
      this.$router.push('../../thank-you');
    });
  }


}
